export const HexLogo = ({ className = "w-8 h-8" }) => (
  <img
    src="/waterboat-logo.png"
    alt="Manifest Waterboat logo"
    className={`${className} object-contain select-none`}
    draggable="false"
  />
);

export default HexLogo;
